export const SHARES_URL = '/shares';
export const REQUEST_TO_SELL_SHARES_URL = '/request-to-sell';
